// extracted by mini-css-extract-plugin
export default {"wrapper_content":"styles_wrapper_content__0+0ST","wrapper":"styles_wrapper__r6iVI","text":"styles_text__UqNGR"};